import {SaldoMassStatusChangeList} from './saldo-mass-status-change-list';

export class SaldoMassStatusChange {
  statusCode: string;
  changeList: SaldoMassStatusChangeList[] = [];
}
